import React, { FC } from "react";
import { SnackbarProvider as MuiSnackbarProvider } from "material-ui-snackbar-provider";
import { Snackbar, Button } from "@material-ui/core";
import { Alert, Color as AlertColor } from "@material-ui/lab";

interface Props {
  children: JSX.Element;
}

export interface CustomParameters {
  autoHideDuration?: number;
  alertSeverity?: AlertColor;
}

const SnackbarProvider: FC<Props> = (props) => {
  return (
    <MuiSnackbarProvider
      SnackbarComponent={(showProps) => {
        const customParameters: CustomParameters | undefined =
          showProps.customParameters;

        function renderAction() {
          if (showProps.action) {
            return (
              <Button
                {...showProps.ButtonProps}
                color="inherit"
                size="small"
                disableElevation
              >
                {showProps.action}
              </Button>
            );
          }
        }

        return (
          <Snackbar
            {...showProps.SnackbarProps}
            autoHideDuration={customParameters?.autoHideDuration || 6000}
            action={showProps.action}
            anchorOrigin={{ horizontal: "center", vertical: "top" }}
          >
            <Alert
              variant="filled"
              severity={customParameters?.alertSeverity || "error"}
              action={renderAction()}
            >
              {showProps.message}
            </Alert>
          </Snackbar>
        );
      }}
    >
      {props.children}
    </MuiSnackbarProvider>
  );
};

export default SnackbarProvider;
